import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { isCustomer } from "../utils/userHelper";

const ProtectedRoute = ({ children, customerOnly = false }) => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // Ako je ruta namenjena samo customer korisnicima, proveri da li je korisnik customer
  if (customerOnly && user && !isCustomer(user)) {
    return <Navigate to="/dashboard" />;
  }

  return children;
};

export default ProtectedRoute;


